// The card's aggregator: the period's scanned games by the score they came
// out of the opening with, in the five change bands (`changeBandOf`,
// `@chess/api-model`: gained by 2 pawns or more, gained a little from half a
// pawn, held, lost a little, lost), the bands the "How each stage goes" bars
// and the library's `stage-change` filter use. Registered with the game
// store by this plugin's setup.
import { aggregatorId, changeBandOf, CHANGE_BANDS, type Accumulator, type Aggregator, type ChangeBand } from '@chess/api-model';

export { CHANGE_BANDS, type ChangeBand };

/** What the card shows: games in each band; they add up to the games scored. */
export interface OpeningResultsResult {
  by: Record<ChangeBand, number>;
}

export const emptyBands = (): Record<ChangeBand, number> => ({ gained: 0, 'slightly-gained': 0, held: 0, 'slightly-lost': 0, lost: 0 });

export class OpeningResultsAggregator implements Aggregator<OpeningResultsResult> {
  readonly id = aggregatorId('opening-results');

  start(): Accumulator<OpeningResultsResult> {
    const by = emptyBands();
    return {
      add: (game) => {
        if (game.scanned && game.openingScore !== undefined) by[changeBandOf(game.openingScore)] += 1;
      },
      result: () => ({ by }),
    };
  }
}
